<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	// Stores
	import PromotionStore from '@/Stores/PromotionStore';
	// Partials
	import BulkBonus from '@/Partials/Promotions/_BulkBonus.svelte';
	import AllPromotions from '@/Partials/Promotions/Types/_AllPromotions.svelte';
	import NextDepositMatch from '@/Partials/Promotions/Types/_NextDepositMatch.svelte';
	import RacingMoneyBack from '@/Partials/Promotions/Types/_RacingMoneyBack.svelte';
	import SportsMoneyBack from '@/Partials/Promotions/Types/_SportsMoneyBack.svelte';
	import SGMMoneyBack from '@/Partials/Promotions/Types/_SGMMoneyBack.svelte';
	import Helmet from '@/Components/Helmet.svelte';

	export let slug;

	const PromoMap = [
		{
			id: 1,
			slug: 'next_deposit_match',
			title: 'Next Deposit Match',
			component: NextDepositMatch
		},
		{
			id: 2,
			slug: 'racing_money_back',
			title: 'Racing Money Back',
			component: RacingMoneyBack
		},
		{
			id: 3,
			slug: 'sports_money_back',
			title: 'Sports Money Back',
			component: SportsMoneyBack
		},
		{
			id: 4,
			slug: 'SGM_money_back',
			title: 'SGM Money Back',
			component: SGMMoneyBack
		}
	];

	$: selectedPromotionType = slug && getCurrentPromo();
	let selectedPromotionId;
	let bulkUserBonuses = false;

	function getCurrentPromo() {
		if (!isNaN(parseInt(slug))) {
			selectedPromotionId = parseInt(slug);
			PromotionStore.getPromotionById(selectedPromotionId);

			return null;
		}
		for (let promotion in PromoMap) {
			if (slug === PromoMap[promotion].slug) {
				return PromoMap[promotion];
			}
		}

		return null;
	}
</script>

<Helmet title="Promotions list" />
<div>
	<div>
		<!-- Page Header -->
		<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
			<div class="flex items-center justify-between w-full">
				<div class="flex-1 text-left">
					<h1 class="text-xl font-bold">Promotions</h1>
				</div>
				<div class="flex-1 text-center">
					<div class="btn-group">
						<Link
							href={'/promotions'}
							class="btn whitespace-nowrap {slug === null ? 'btn-primary-action' : 'btn-muted text-dark'}"
						>
							All Promotions
						</Link>
						{#each PromoMap as promoMapOptions (promoMapOptions.id)}
							<Link
								href={`/promotions/${promoMapOptions.slug}`}
								class="btn whitespace-nowrap {promoMapOptions.slug === slug
									? 'btn-primary-action'
									: 'btn-muted text-dark'}"
							>
								{promoMapOptions.title}
							</Link>
						{/each}
					</div>
				</div>
				<div class="flex-1 text-right">
					<button
						class="btn btn-primary"
						on:click={() => {
							bulkUserBonuses = true;
						}}
					>
						Bulk Bonus Upload
					</button>
				</div>
			</div>
		</div>
		<!-- End Page Header -->
		<!-- Page -->
		{#if selectedPromotionType}
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<!-- SELECTED PROMO COMPONENT -->
				<svelte:component this={selectedPromotionType.component} />
			</div>
		{:else}
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<AllPromotions bind:promotionId={selectedPromotionId} />
			</div>
		{/if}
		<!-- End Page -->
	</div>
</div>

{#if bulkUserBonuses}
	<BulkBonus bind:open={bulkUserBonuses} />
{/if}
